import { t } from "i18next";
import { DayPicker } from "react-day-picker";
import "react-day-picker/dist/style.css";
import moment from "moment";

const BettingHistoryFilter = ({
  setShow,
  show,
  setFilter,
  filter,
  settled,
}) => {
  return (
    <div
      _ngcontent-serverapp-c2684251700
      className={`searchpage ng-tns-c2684251700-125 ng-star-inserted ${
        show ? "active" : ""
      } `}
    >
      <div
        _ngcontent-serverapp-c2684251700
        className="search-top-info ng-tns-c2684251700-125"
      >
        <h6
          _ngcontent-serverapp-c2684251700
          className="ng-tns-c2684251700-125 ng-star-inserted"
        >
          {t("BettingRecordFilter")}
        </h6>

        <div
          onClick={() => setShow(false)}
          _ngcontent-serverapp-c2684251700
          className="back ng-tns-c2684251700-125"
          style={{
            "mask-image": 'url("/assets/Other/icon-arrow-type01.svg")',
          }}
        >
          Back
        </div>
      </div>
      <div
        _ngcontent-serverapp-c2684251700
        className="searchpage-main ng-tns-c2684251700-125"
      >
        {/* <div
          _ngcontent-serverapp-c2684251700
          className="search-checkbox-group check-group ng-tns-c2684251700-125 ng-star-inserted"
        >
          <h2
            _ngcontent-serverapp-c2684251700
            className="ng-tns-c2684251700-125 ng-star-inserted"
          >
            {t("Platform")}
          </h2>

          <ul
            _ngcontent-serverapp-c2684251700
            className="ng-tns-c2684251700-125"
          >
            {gameProviders?.map((res) => {
              return (
                <li
                  onClick={() =>
                    setFilter((prev) => {
                      return {
                        ...prev,
                        platform: res?.name,
                      };
                    })
                  }
                  _ngcontent-serverapp-c2684251700
                  className="ng-tns-c2684251700-125 ng-star-inserted"
                >
                  <input
                    _ngcontent-serverapp-c2684251700
                    className="ng-tns-c2684251700-125"
                    type="checkbox"
                    checked={filter?.platform === res?.name}
                  />
                  <label
                    _ngcontent-serverapp-c2684251700
                    className="ng-tns-c2684251700-125"
                  >
                    <span
                      _ngcontent-serverapp-c2684251700
                      className="ng-tns-c2684251700-125"
                    >
                      {res?.name}
                    </span>
                    <i
                      _ngcontent-serverapp-c2684251700
                      className="ng-tns-c2684251700-125"
                      style={{
                        "background-image": `url("/assets/Other/check.svg")`,
                      }}
                    />
                  </label>
                </li>
              );
            })}
          </ul>
        </div> */}
        <div
          _ngcontent-serverapp-c2684251700
          className="search-checkbox-group check-group ng-tns-c2684251700-125 ng-star-inserted"
        >
          <h2
            _ngcontent-serverapp-c2684251700
            className="ng-tns-c2684251700-125 ng-star-inserted"
          >
            {t("GameType")}
          </h2>

          <ul
            _ngcontent-serverapp-c2684251700
            className="ng-tns-c2684251700-125"
          >
            {gameCategories?.map((res) => {
              return (
                <li
                  onClick={() =>
                    setFilter((prev) => {
                      return {
                        ...prev,
                        gameType: res?.name,
                      };
                    })
                  }
                  _ngcontent-serverapp-c2684251700
                  className="ng-tns-c2684251700-125 ng-star-inserted"
                >
                  <input
                    _ngcontent-serverapp-c2684251700
                    className="ng-tns-c2684251700-125"
                    type="checkbox"
                    checked={filter?.gameType === res?.name}
                  />
                  <label
                    _ngcontent-serverapp-c2684251700
                    className="ng-tns-c2684251700-125"
                  >
                    <span
                      _ngcontent-serverapp-c2684251700
                      className="ng-tns-c2684251700-125"
                    >
                      {res?.name}
                    </span>
                    <i
                      _ngcontent-serverapp-c2684251700
                      className="ng-tns-c2684251700-125"
                      style={{
                        "background-image": `url("/assets/Other/check.svg")`,
                      }}
                    />
                  </label>
                </li>
              );
            })}
          </ul>
        </div>
        {settled && (
          <div
            _ngcontent-serverapp-c2684251700
            className="search-checkbox-group check-group ng-tns-c2684251700-125 ng-star-inserted"
          >
            <h2
              _ngcontent-serverapp-c2684251700
              className="ng-tns-c2684251700-125 ng-star-inserted"
            >
              {t("Date")}
            </h2>

            <ul
              _ngcontent-serverapp-c2684251700
              className="ng-tns-c2684251700-125"
            >
              {timeRanges?.map((res) => {
                return (
                  <li
                    onClick={() =>
                      setFilter((prev) => {
                        return {
                          ...prev,
                          fromPeriod: res?.getDays()?.fromPeriod,
                          toPeriod: res?.getDays()?.toPeriod,
                        };
                      })
                    }
                    _ngcontent-serverapp-c2684251700
                    className="ng-tns-c2684251700-125 ng-star-inserted"
                  >
                    <input
                      _ngcontent-serverapp-c2684251700
                      className="ng-tns-c2684251700-125"
                      type="checkbox"
                      checked={
                        filter?.fromPeriod === res?.getDays()?.fromPeriod &&
                        filter?.toPeriod === res?.getDays()?.toPeriod
                      }
                    />
                    <label
                      _ngcontent-serverapp-c2684251700
                      className="ng-tns-c2684251700-125"
                    >
                      <span
                        _ngcontent-serverapp-c2684251700
                        className="ng-tns-c2684251700-125"
                      >
                        {res?.name}
                      </span>
                      <i
                        _ngcontent-serverapp-c2684251700
                        className="ng-tns-c2684251700-125"
                        style={{
                          "background-image": `url("/assets/Other/check.svg")`,
                        }}
                      />
                    </label>
                  </li>
                );
              })}
            </ul>
          </div>
        )}
        {settled && (
          <div
            _ngcontent-serverapp-c2684251700
            className="search-checkbox-group check-group ng-tns-c2684251700-125 ng-star-inserted"
          >
            <h2
              _ngcontent-serverapp-c2684251700
              className="ng-tns-c2684251700-125 ng-star-inserted"
            >
              Date Range
            </h2>

            <DayPicker
              mode="range"
              selected={{
                from: filter?.fromPeriod
                  ? moment(filter.fromPeriod, "YYYY-MM-DD").toDate()
                  : undefined,
                to: filter?.toPeriod
                  ? moment(filter.toPeriod, "YYYY-MM-DD").toDate()
                  : undefined,
              }}
              onSelect={(e) =>
                setFilter((prev) => {
                  return {
                    ...prev,
                    fromPeriod: e?.from
                      ? moment(e.from).format("YYYY-MM-DD")
                      : undefined,
                    toPeriod: e?.to
                      ? moment(e.to).format("YYYY-MM-DD")
                      : undefined,
                  };
                })
              }
              style={{
                "--rdp-accent-color": "#ffb80c" /* selected date → green */,
                "--rdp-accent-background-color":
                  "#043b3d" /* range highlight → gold */,
                "--rdp-day-color": "white",
                color: "white",
              }}
              disabled={{ after: new Date() }}
            />
          </div>
        )}
      </div>

      <div
        onClick={() => setShow(false)}
        _ngcontent-serverapp-c2684251700
        className="searchpage-bar ng-tns-c2684251700-125"
      >
        <div
          _ngcontent-serverapp-c2684251700
          className="button btn-primary ng-tns-c2684251700-125"
        >
          {t("Confirm")}
        </div>
      </div>
    </div>
  );
};

export default BettingHistoryFilter;

const gameProviders = [
  { name: "MICRO GAMING" },
  { name: "DRAGOONSOFT" },
  { name: "DG" },
  { name: "E1 SPORT" },
  { name: "FA CHAI" },
  { name: "FAST SPIN" },
  { name: "HORSEBOOK" },
  { name: "HOT ROAD" },
  { name: "JILI" },
  { name: "KINGMIDAS" },
  { name: "LADYLUCK" },
  { name: "LUDO" },
  { name: "PINNACLE" },
  { name: "PRAGMATIC PLAY" },
  { name: "PLAY TECH" },
  { name: "PLAY8" },
  { name: "RED TIGER" },
  { name: "SEXY" },
  { name: "SV388" },
  { name: "SPADE GAMING" },
  { name: "VIA" },
  { name: "YL" },
  { name: "YELLOW BAT" },
  { name: "CG" },
  { name: "RWB" },
  { name: "SABA" },
  { name: "JDB" },
  { name: "CQ9" },
  { name: "PG SOFT" },
  { name: "EVOLUTION" },
  { name: "BTi" },
  { name: "JOKER" },
  { name: "E2 EXCHANGE" },
  { name: "SBO" },
  { name: "WM" },
  { name: "NETENT" },
  { name: "UG" },
  { name: "PLAY‘N GO" },
  { name: "RICH88" },
  { name: "WORLD MATCH" },
  { name: "9 WICKETS" },
  { name: "E2 SPORTS" },
  { name: "SPRIBE" },
  { name: "CMD368" },
  { name: "NEXTSPIN" },
  { name: "LUCKY365" },
];

const gameCategories = [
  { name: "Casino" },
  { name: "BetFair" },
  { name: "Bookmaker" },
  { name: "SportsBook" },
  { name: "Fancy" },
];

const timeRanges = [
  {
    name: "Today",
    getDays: () => ({
      fromPeriod: moment().format("YYYY-MM-DD"),
      toPeriod: moment().format("YYYY-MM-DD"),
    }),
  },
  {
    name: "Yesterday",
    getDays: () => ({
      fromPeriod: moment().subtract(1, "days").format("YYYY-MM-DD"),
      toPeriod: moment().format("YYYY-MM-DD"),
    }),
  },
  {
    name: "Last 7 days",
    getDays: () => ({
      fromPeriod: moment().subtract(6, "days").format("YYYY-MM-DD"),
      toPeriod: moment().format("YYYY-MM-DD"),
    }),
  },
  {
    name: "Last 30 days",
    getDays: () => ({
      fromPeriod: moment().subtract(29, "days").format("YYYY-MM-DD"),
      toPeriod: moment().format("YYYY-MM-DD"),
    }),
  },
];
